import React, { FC } from "react";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";
import { iDataUser } from "../../../../interfaces/SuperAdmin/Pages/iDataUser";
import { Button, IconButton, Tooltip } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useAuthContext } from "../../../../hooks/Auth";
import { useNavigate } from "react-router-dom";
import { formatFechaWithHour } from "../../../../utils/dateFunctions";

interface Props {
  usuario: iDataUser;
  index: number;
  assignToDeleteUser: (userId: string) => void;
  handleEdit: (user: iDataUser) => void;
}

const RowUser: FC<Props> = ({
  usuario,
  index,
  assignToDeleteUser,
  handleEdit,
}) => {
  const { user } = useAuthContext();
  const navigate = useNavigate();

  return (
    <StyledTableRow>
      <StyledTableCell>{index + 1}</StyledTableCell>
      <StyledTableCell>{usuario.nombres}</StyledTableCell>
      <StyledTableCell>{usuario.apellidos}</StyledTableCell>
      <StyledTableCell>{usuario.email}</StyledTableCell>
      <StyledTableCell>
        {formatFechaWithHour(usuario.created_at)}
      </StyledTableCell>
      <StyledTableCell>{usuario.estado}</StyledTableCell>

      <StyledTableCell align="center">
        <Button sx={{ color: "#336B87" }} onClick={() => handleEdit(usuario)}>
          <Tooltip title="Editar usuario">
            <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>

        <Button
          sx={{ color: "#336B87" }}
          onClick={() => assignToDeleteUser(usuario.id_usuario)}
        >
          <Tooltip title="Eliminar usuario">
            <IconButton aria-label="delete" sx={{ color: "#336B87" }}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>

        <Button
          sx={{ color: "#336B87" }}
          onClick={() =>
            navigate(
              `/asistente/users/${user?.id_organizacion}/${usuario.id_usuario}`
            )
          }
        >
          <Tooltip title="Ver suscripciones">
            <IconButton aria-label="suscripcion" sx={{ color: "#336B87" }}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default RowUser;
